"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const flush_1 = require("../node/flush");
class TwingTokenParserFlush extends token_parser_1.TwingTokenParser {
    parse(token) {
        this.parser.getStream().expect(token_1.TwingToken.BLOCK_END_TYPE);
        return new flush_1.TwingNodeFlush(token.getLine(), token.getColumn(), this.getTag());
    }
    getTag() {
        return 'flush';
    }
}
exports.TwingTokenParserFlush = TwingTokenParserFlush;
